import {
  getAuthParamsFromAuthKey,
  getAuthKeyType,
  AuthKeyType,
} from '@shopee-user/authentication-utils/src/auth';

export { AuthKeyType };

export const getAuthKeyTypeFromAuthKey = (authKey: string): AuthKeyType =>
  getAuthKeyType(
    getAuthParamsFromAuthKey({
      authKey,
      isAllowEmail: true,
      isAllowPhone: true,
    })
  );
